// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import {
  ConfigProvider,
  App,
} from 'antd';
import { ApplyPluginsType } from 'umi';
import { getPluginManager } from '../core/plugin';
import { AntdConfigContext, AntdConfigContextSetter } from './context';
import merge from '/Users/jialun/develop/vscode/2025/ymd_portal/node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/merge'

let cacheAntdConfig = null;

const getAntdConfig = () => {
  if(!cacheAntdConfig){
    cacheAntdConfig = getPluginManager().applyPlugins({
      key: 'antd',
      type: ApplyPluginsType.modify,
      initialValue: {
        ...{"theme":{"cssVar":true,"token":{"colorPrimary":"#3370FF","colorPrimaryBg":"#F0F4FF","colorPrimaryBgHover":"#E6EFFF","colorPrimaryBorder":"#B3D1FF","colorPrimaryBorderHover":"#8CC8FF","colorPrimaryHover":"#4D7FFF","colorPrimaryActive":"#1E5AFF","colorPrimaryTextHover":"#4D7FFF","colorPrimaryText":"#3370FF","colorPrimaryTextActive":"#1E5AFF","colorInfo":"#3370FF","colorLink":"#3370FF","colorLinkHover":"#4D7FFF","colorLinkActive":"#1E5AFF","colorSuccess":"#00B365","colorSuccessBg":"#F0F9F4","colorSuccessBorder":"#B3E5CC","colorWarning":"#FF8A00","colorWarningBg":"#FFF7F0","colorWarningBorder":"#FFD1B3","colorError":"#FF4757","colorErrorBg":"#FFF0F1","colorErrorBorder":"#FFB3BA","colorBgBase":"#FFFFFF","colorBgContainer":"#FFFFFF","colorBgElevated":"#FFFFFF","colorBgLayout":"#FAFBFC","colorBgSpotlight":"#F8F9FA","colorBgCompanyIntro":"#F5F9FF","colorBgWorktoolSection":"#F3F7FE","colorBgMask":"rgba(0, 0, 0, 0.45)","colorText":"#1A202C","colorTextSecondary":"#4A5568","colorTextTertiary":"#718096","colorTextQuaternary":"#A0AEC0","colorTextDescription":"#718096","colorTextHeading":"#1A202C","colorTextLabel":"#2D3748","colorTextPlaceholder":"#A0AEC0","colorTextDisabled":"#CBD5E0","colorBorder":"#E2E8F0","colorBorderSecondary":"#EDF2F7","marginXS":4,"marginSM":8,"margin":12,"marginMD":16,"marginLG":24,"marginXL":32,"marginXXL":48,"borderRadius":8,"borderRadiusXS":4,"borderRadiusSM":6,"borderRadiusLG":12,"borderRadiusOuter":16,"boxShadow":"0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)","boxShadowSecondary":"0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.06)","boxShadowTertiary":"0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)","fontFamily":"Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"","fontFamilyCode":"\"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, Courier, monospace","fontSizeHeading1":36,"fontSizeHeading2":28,"fontSizeHeading3":22,"fontSizeHeading4":18,"fontSizeHeading5":16,"fontSize":16,"fontSizeSM":14,"fontSizeLG":18,"fontSizeXL":22,"fontWeightStrong":600,"lineHeight":1.8,"lineHeightLG":1.7,"lineHeightSM":1.9,"controlHeight":36,"controlHeightSM":28,"controlHeightLG":44,"controlHeightXS":24,"motionDurationFast":"0.1s","motionDurationMid":"0.2s","motionDurationSlow":"0.3s","motionEaseInOut":"cubic-bezier(0.645, 0.045, 0.355, 1)","motionEaseOut":"cubic-bezier(0.215, 0.61, 0.355, 1)"},"components":{"Card":{"paddingSM":16,"padding":24,"paddingLG":32,"borderRadiusLG":12,"boxShadowTertiary":"0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1)"},"Button":{"borderRadius":8,"borderRadiusLG":10,"borderRadiusSM":6,"controlHeight":36,"controlHeightLG":44,"controlHeightSM":28,"fontWeight":500,"paddingInline":16,"paddingInlineLG":20,"paddingInlineSM":12},"Input":{"borderRadius":8,"controlHeight":36,"controlHeightLG":44,"controlHeightSM":28,"paddingInline":12},"Select":{"borderRadius":8,"controlHeight":36,"controlHeightLG":44,"controlHeightSM":28},"Typography":{"titleMarginBottom":"0.5em","titleMarginTop":"1.2em"},"Divider":{"marginLG":24,"margin":16},"Space":{"size":12,"sizeLG":24,"sizeSM":8}}}},
        appConfig: {},
      },
    });
    if (!cacheAntdConfig.theme) {
      cacheAntdConfig.theme = {};
    }
  }
  return cacheAntdConfig;
}

function AntdProvider({ children }) {
  let container = children;

  const [antdConfig, _setAntdConfig] = React.useState(() => {
    const {
      appConfig: _,
      ...finalConfigProvider
    } = getAntdConfig();
    return finalConfigProvider
  });
  const setAntdConfig: typeof _setAntdConfig = (newConfig) => {
    _setAntdConfig(prev => {
      return merge({}, prev, typeof newConfig === 'function' ? newConfig(prev) : newConfig)
    })
  }


  if (antdConfig.prefixCls) {
    ConfigProvider.config({
      prefixCls: antdConfig.prefixCls,
    });
  };

  if (antdConfig.iconPrefixCls) {
    // Icons in message need to set iconPrefixCls via ConfigProvider.config()
    ConfigProvider.config({
      iconPrefixCls: antdConfig.iconPrefixCls,
    });
  };

  if (antdConfig.theme) {
    // Pass config theme to static method
    ConfigProvider.config({
      theme: antdConfig.theme,
    });
  }

  container = <ConfigProvider {...antdConfig}>{container}</ConfigProvider>;


  container = (
    <AntdConfigContextSetter.Provider value={setAntdConfig}>
      <AntdConfigContext.Provider value={antdConfig}>
        {container}
      </AntdConfigContext.Provider>
    </AntdConfigContextSetter.Provider>
  )

  return container;
}

export function rootContainer(children) {
  return (
    <AntdProvider>
      {children}
    </AntdProvider>
  );
}

// The App component should be under ConfigProvider
// plugin-locale has other ConfigProvider
export function innerProvider(container: any) {
  const {
    appConfig: finalAppConfig = {},
  } = getAntdConfig();
  return <App {...finalAppConfig}>{container}</App>;
}
